<template>
  <Transition name="fade">
    <div v-if="show" class="payment-processing-overlay">
      <div class="processing-content">
        <div class="progress-container">
          <div class="spinner"></div>
        </div>
        <h2 class="processing-title mb-3">Processing Your Payment</h2>
        <p class="processing-message">{{ currentMessage }}</p>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { ref, watch, onUnmounted } from 'vue'

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
})

const messages = [
  'Please do not close this page',
  'Securely connecting to payment provider...',
  'Verifying your information...',
  'Almost there...',
  'Finalizing your payment...'
]

const currentMessage = ref(messages[0])
let messageIndex = 0
let messageInterval = null

watch(
  () => props.show,
  (newValue) => {
    if (newValue) {
      messageIndex = 0
      currentMessage.value = messages[0]
      startMessageCycle()
    }
  }
)

function startMessageCycle() {
  // Clear any existing interval first
  if (messageInterval) {
    clearInterval(messageInterval)
  }

  messageInterval = setInterval(() => {
    if (!props.show) {
      clearInterval(messageInterval)
      messageInterval = null
      return
    }

    messageIndex = (messageIndex + 1) % messages.length
    currentMessage.value = messages[messageIndex]
  }, 3000)
}

onUnmounted(() => {
  if (messageInterval) {
    clearInterval(messageInterval)
    messageInterval = null
  }
})
</script>
